import {Fragment, useEffect, useState, useContext} from 'react';

import classes from './PreRegContainer.module.scss';
import PreRegistration from './PreRegInitial/PreReg';
import AlternativeOptions from './AlternativeOptions/AlternativeOptions';
import MainOptions from './MainOptions/MainOptions';
import LoginContext from '../../../../store/login-context';
import BinuyShikun from './BinuyShikun/BinuyShikun';
import BioIdFirst from './BiometricID/BioIdFirst';
import BioIdCode from './BiometricID/BioIdCode';
import SummaryOptions from './SummaryOptions/SummaryOptions';
import ServicePositions from './ServicePositions/ServicePositions';
import Introduction from './Introduction/Introduction';
import PibaNoCard from './PibaNoCard/PibaNoCard';
import PibaNoCode from './PibaNoCode/PibaNoCode';
import Marketing from './Marketing/Marketing';


declare function Translate(key: string): string;
declare var _loginMethodSmsOtpUrl: any;
declare var _siteSettings: any;
declare var _curLang: any;


const PreRegContainer = () => {

    const ctx = useContext(LoginContext);

    const [currentScreen,setCurrentScreen] = useState('');
    const [userStepsMap,setUserStepsMap] = useState<string[]>([]);
           
    useEffect(() => {        
        if(ctx.skipMainRegForm){            
            setCurrentScreen(ctx.preRegScreenCollection.introduction); 
        }        
        else{
            setCurrentScreen(ctx.preRegScreenCollection.initial);
        }
                                  
    },[]);
   
    const backToLoginPage = () => {
        window.location = _loginMethodSmsOtpUrl;
    };

    const backToLoginPagePress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            backToLoginPage();  
        }
    }

    const forwardToForgotPassword = () => {
        window.location.href = `${_siteSettings.forgottenPasswordLink}&locale=${_curLang}`;
    };

    const forwardToForgotPassPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            forwardToForgotPassword();  
        }
    }

    const handleScreenChange = (current:string) => {
        setCurrentScreen(current);
    };

    const handleAddUserStep = (newStep:string) => {
        setUserStepsMap([...userStepsMap,newStep]);        
    };

    const handlePrevScreen = () => {
        userStepsMap.pop();
        setUserStepsMap(userStepsMap);        
        setCurrentScreen(userStepsMap[userStepsMap.length-1]);                
    };

    const handleExitReg = () => {
        window.location = _loginMethodSmsOtpUrl;
    };

    const handleExitRegPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            handleExitReg();  
        }
    };

    const handleFirstScreen = () => {
        setUserStepsMap([ctx.preRegScreenCollection.mainOptions]);
        setCurrentScreen(ctx.preRegScreenCollection.mainOptions);
    };

    const updateUserDetails = (userId:string, mail:string, phoneNumber:string) => {
        ctx.updatePreRegUser([userId,mail,phoneNumber]);
    };

    const handleToMarketClick = () => {
        ctx.toggleMarketFocus();        
    };

    const handleToMarketPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            handleToMarketClick();  
        }
    };

    return(
        <Fragment>
             <div className={classes.preRegContainer}>  
                <div className={classes.preRegTitleContainer}>
                    <div role="heading" aria-level={1}>
                        <span className={classes.preRegTitle}>{Translate("N_General_SignUp_title_1")}</span>
                    </div>
                    {currentScreen === ctx.preRegScreenCollection.initial &&
                        <div className={classes.preRegTitleLinksWrapper}  role="heading" aria-level={2}>
                             <a 
                                className={classes.signup_reason}
                                tabIndex={0} 
                                onClick={handleToMarketClick}
                                onKeyPress={handleToMarketPress}                                
                            >{Translate('N_General_Signup_Why_To')}</a>

                            <span className={classes.seperator}>|</span>

                            <span className={classes.preRegTitleLinkText}>{Translate('N_General_SignUp_lobby_info_3')}</span>
                            <a 
                                className={classes.preRegTitleLink1}
                                tabIndex={0} 
                                onClick={backToLoginPage}
                                onKeyPress={backToLoginPagePress}
                            >{Translate('N_General_Back_To_Login')}</a>
                            <span className={classes.preRegTitleLinkText}>{Translate('N_General_Or_Maybe')}</span>
                            <a 
                                className={classes.preRegTitleLink2}
                                tabIndex={0} 
                                onClick={forwardToForgotPassword}
                                onKeyPress={forwardToForgotPassPress}
                            >{Translate('N_General_Forgot_Password')}</a>
                        </div>
                    }
                    {currentScreen !== ctx.preRegScreenCollection.initial &&    
                        <div className={classes.exitReg}>
                            <span 
                                className={classes.exitRegIcon}
                                aria-hidden="true"                                 
                                onClick={handleExitReg}                                
                                >X</span>
                            <span 
                                className={classes.exitRegText} 
                                role="link" 
                                tabIndex={0} 
                                onClick={handleExitReg}
                                onKeyPress={handleExitRegPress}
                                >
                                    {Translate('N_General_SignUp_Exit')}
                            </span>                           
                        </div>
                    }
                </div>  
                <div >
                    {currentScreen === ctx.preRegScreenCollection.initial &&  <PreRegistration setCurrentScreenStep={handleScreenChange} AddUserStep={handleAddUserStep} setUserDetails={updateUserDetails}/>} 
                    {currentScreen === ctx.preRegScreenCollection.introduction &&  <Introduction setCurrentScreenStep={handleScreenChange} AddUserStep={handleAddUserStep} />} 
                    {currentScreen === ctx.preRegScreenCollection.mainOptions && <MainOptions setCurrentScreenStep={handleScreenChange} AddUserStep={handleAddUserStep} prevScreen={handlePrevScreen} />}
                    {currentScreen === ctx.preRegScreenCollection.alternativeOptions && <AlternativeOptions setCurrentScreenStep={handleScreenChange} AddUserStep={handleAddUserStep} prevScreen={handlePrevScreen} />}
                    {currentScreen === ctx.preRegScreenCollection.binuyShikun && <BinuyShikun setCurrentScreenStep={handleScreenChange} AddUserStep={handleAddUserStep} prevScreen={handlePrevScreen} />}
                    {currentScreen === ctx.preRegScreenCollection.bioIdFirst && <BioIdFirst setCurrentScreenStep={handleScreenChange} AddUserStep={handleAddUserStep} prevScreen={handlePrevScreen} />}
                    {currentScreen === ctx.preRegScreenCollection.bioIdCode && <BioIdCode setCurrentScreenStep={handleScreenChange} AddUserStep={handleAddUserStep} prevScreen={handlePrevScreen} />}                    
                    {currentScreen === ctx.preRegScreenCollection.summaryOptions && <SummaryOptions setCurrentScreenStep={handleScreenChange} AddUserStep={handleAddUserStep} prevScreen={handlePrevScreen} />}
                    {currentScreen === ctx.preRegScreenCollection.servicePositions && <ServicePositions setCurrentScreenStep={handleScreenChange} AddUserStep={handleAddUserStep} prevScreen={handlePrevScreen} firstScreen={handleFirstScreen} />}
                    {currentScreen === ctx.preRegScreenCollection.pibaNoCard && <PibaNoCard setCurrentScreenStep={handleScreenChange} AddUserStep={handleAddUserStep} prevScreen={handlePrevScreen} firstScreen={handleFirstScreen} />}
                    {currentScreen === ctx.preRegScreenCollection.pibaNoCode && <PibaNoCode setCurrentScreenStep={handleScreenChange} AddUserStep={handleAddUserStep} prevScreen={handlePrevScreen} firstScreen={handleFirstScreen} />}
                </div>                      
            </div>
                                        
        </Fragment>
    );
};
export default PreRegContainer;